import { f32, vec2f } from 'typegpu/data'
import { abs, acos, acosh, asin, asinh, atan, atan2, atanh, ceil, clamp, cos, cosh, cross, degrees, distance, dot, exp, exp2, floor, fract, inverseSqrt, length, log, log2, max, min, mix, mod, normalize, pow, radians, round, select, sign, sin, sinh, smoothstep, sqrt, step, tan, tanh, trunc, } from 'typegpu/std'
import { EPS, EPS_TINY, PI } from '../../constants'

export const BUILTIN_EXTERNALS: Record<string, unknown> = {
  f32,
  vec2f,
  abs,
  acos,
  acosh,
  asin,
  asinh,
  atan,
  atan2,
  atanh,
  ceil,
  clamp,
  cos,
  cosh,
  cross,
  degrees,
  distance,
  dot,
  exp,
  exp2,
  floor,
  fract,
  inverseSqrt,
  length,
  log,
  log2,
  max,
  min,
  mix,
  mod,
  normalize,
  pow,
  radians,
  round,
  select,
  sign,
  sin,
  sinh,
  smoothstep,
  sqrt,
  step,
  tan,
  tanh,
  trunc,
  EPS,
  EPS_TINY,
  PI,
}

export const BUILTIN_ARITY: Record<string, number | number[]> = {
  f32: [0, 1],
  vec2f: [0, 1, 2],
  abs: 1,
  acos: 1,
  acosh: 1,
  asin: 1,
  asinh: 1,
  atan: 1,
  atan2: 2,
  atanh: 1,
  ceil: 1,
  clamp: 3,
  cos: 1,
  cosh: 1,
  cross: 2,
  degrees: 1,
  distance: 2,
  dot: 2,
  exp: 1,
  exp2: 1,
  floor: 1,
  fract: 1,
  inverseSqrt: 1,
  length: 1,
  log: 1,
  log2: 1,
  max: 2,
  min: 2,
  mix: 3,
  mod: 2,
  normalize: 1,
  pow: 2,
  radians: 1,
  round: 1,
  select: 3,
  sign: 1,
  sin: 1,
  sinh: 1,
  smoothstep: 3,
  sqrt: 1,
  step: 2,
  tan: 1,
  tanh: 1,
  trunc: 1,
}
